// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","social":"Footer_social__iB1oi","cv":"Footer_cv__u3Rrp"};